null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js/v0.6.32/library/src/main/scala/scala/scalajs/js/JSNumberOps.scala